export default "__VITE_PUBLIC_ASSET__f1fafd7b__"